/*
 * Benoits custom scripts.
 * Kept out of theme.js so custom behaviour survives base-theme upgrades.
 */
(function () {
  /*
   * Slideshow: pause autoplay while hovered.
   * Enabled per section by the "Pause on hover" setting, which outputs
   * data-pause-on-hover on the Flickity element. Listeners are delegated from
   * document so they survive section re-renders in the theme editor.
   */
  var PAUSE_ON_HOVER = '[data-pause-on-hover="true"]';

  // Touch devices fire emulated mouseenter on tap, which would pause the
  // slider until the visitor taps elsewhere. Only act where hover is real.
  function canHover() {
    return window.matchMedia && window.matchMedia('(hover: hover)').matches;
  }

  function getFlickity(el) {
    if (!window.Flickity || typeof window.Flickity.data !== 'function') return null;
    var flkty = window.Flickity.data(el);
    return flkty && flkty.player ? flkty : null;
  }

  document.addEventListener('mouseenter', function (evt) {
    var el = evt.target;
    if (!(el instanceof Element) || !el.matches(PAUSE_ON_HOVER) || !canHover()) return;

    var flkty = getFlickity(el);
    if (flkty && flkty.player.state === 'playing') {
      flkty.pausePlayer();
    }
  }, true);

  document.addEventListener('mouseleave', function (evt) {
    var el = evt.target;
    if (!(el instanceof Element) || !el.matches(PAUSE_ON_HOVER)) return;

    // Stay paused if the shopper used the slideshow's own pause button
    var wrapper = el.closest('.slideshow-wrapper');
    var pauseBtn = wrapper && wrapper.querySelector('.slideshow__pause');
    if (pauseBtn && pauseBtn.classList.contains('is-paused')) return;

    var flkty = getFlickity(el);
    if (flkty) {
      flkty.unpausePlayer();
    }
  }, true);
})();
